import React from 'react';
import { NavLink } from 'react-router-dom';

export default ({ userIsMovementSpecialist }) => {
  return (
    <div className="ms-admin__nav">
      <NavLink to="/subscription/ms-admin/profile" className="main-navigation__link" activeClassName="active">
        Profile
      </NavLink>
      {userIsMovementSpecialist && (
        <NavLink to="/subscription/ms-admin/follow-ups" className="main-navigation__link" activeClassName="active">
          Follow-Ups
        </NavLink>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/subscription/movement-specialist-admin/MovementSpecialistAdminNavigation.js